/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DashboardAliases {
  AVATAR_USER = 'avatar-user',
  CARD_AUTORIZACOES = 'card-autorizacoes',
  CARD_MENSAGENS = 'card-mensagens',
  CARD_OPERADORA = 'card-operadora',
  CARD_PLANO = 'card-plano',
  CARD_USER = 'card-user',
  CUSTOM_CARD_AUTORIZACOES = 'custom-card-autorizacoes',
  DASHBOARD_0 = 'dashboard-0',
  DECK_1 = 'deck-1',
  DECK_AUTORIZACOES = 'deck-autorizacoes',
  DYNAMIC_SITUACAO_MENSALIDADE = 'dynamic-situacao-mensalidade',
  DYNAMIC_STATUS_AUTORIZACAO = 'dynamic-status-autorizacao',
  FETCH_AUTORIZACOES = 'fetch-autorizacoes',
  FETCH_CARD_OPERADORA = 'fetch-card-operadora',
  FETCH_CARD_PESSOA = 'fetch-card-pessoa',
  FETCH_MENSALIDADE = 'fetch-mensalidade',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_CPF = 'field-cpf',
  FIELD_DATA_NASCIMENTO = 'field-data-nascimento',
  FIELD_EMAIL = 'field-email',
  FIELD_ENDERECO = 'field-endereco',
  FIELD_NOTA_FISCAL = 'field-nota-fiscal',
  FIELD_RG = 'field-rg',
  FIELD_TELEFONE = 'field-telefone',
  FIELD_TITULARIDADE = 'field-titularidade',
  FIELD_TITULO = 'field-titulo',
  FIELD_TOTAL = 'field-total',
  FIELD_VENCIMENTO = 'field-vencimento',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FRAGMENT_0 = 'fragment-0',
  HPMS_CUSTOM_CARD_MENSALIDADES = 'hpms-custom-card-mensalidades',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_3 = 'layout-3',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LINK_ANS = 'link-ans',
  LINK_AUTORIZACOES_VER_MAIS = 'link-autorizacoes-ver-mais',
  LINK_EMAIL_ANS = 'link-email-ans',
  LINK_EXTRATO_UTILIZACAO = 'link-extrato-utilizacao',
  LINK_MOSTRAR_TODAS_MENSAGENS = 'link-mostrar-todas-mensagens',
  LINK_NUCLEO_FISCALIZACAO_ANS = 'link-nucleo-fiscalizacao-ans',
  LINK_PLANO_VER_MAIS = 'link-plano-ver-mais',
  LINK_ROL_PROCEDIMENTOS = 'link-rol-procedimentos',
  LINK_TABELA_PRECO = 'link-tabela-preco',
  LINK_TELEFONE_ANS = 'link-telefone-ans',
  LINK_TELEFONE_OPERADORA = 'link-telefone-operadora',
  LINK_USER_VER_MAIS = 'link-user-ver-mais',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_6 = 'panel-6',
  PANEL_7 = 'panel-7',
  PANEL_8 = 'panel-8',
  PANEL_9 = 'panel-9',
  PANEL_10 = 'panel-10',
  PANEL_11 = 'panel-11',
  PANEL_12 = 'panel-12',
  PANEL_13 = 'panel-13',
  PANEL_AUTORIZACOES = 'panel-autorizacoes',
  PANEL_MENSALIDADE = 'panel-mensalidade',
  PANEL_MOSTRAR_TODAS_MENSAGENS = 'panel-mostrar-todas-mensagens',
  PHONE_NUMBER_0 = 'phone-number-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_20 = 'text-20',
  TEXT_MENSALIDADE_TOTAL = 'text-mensalidade-total',
  TEXT_TITULO = 'text-titulo',
  TEXT_ULTIMO_ACESSO = 'text-ultimo-acesso',
}
export { DashboardAliases };
